import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsers2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 14v-1.333A2.667 2.667 0 0 0 8.333 10H4A2.667 2.667 0 0 0 1.333 12.667V14",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.167 7.333A2.667 2.667 0 1 0 6.167 2a2.667 2.667 0 0 0 0 5.333Z",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.667 14v-1.333a2.667 2.667 0 0 0-2-2.58M10 2.087a2.667 2.667 0 0 1 0 5.166",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUsers2;
